/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Session_Register_NoneInputs */

const th_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีผู้ลงทะเบียนในค่ายนี้`)
};

const en_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody is entered in this camp yet.`)
};

const ja_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このキャンプにはまだ参加者がいません。`)
};

const zh_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚无人报名此训练营。`)
};

const es_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay nadie inscrito en este campus.`)
};

const pt_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguém inscrito nesta clínica ainda.`)
};

const id_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada yang mendaftar di kamp ini.`)
};

const fr_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personne n’est inscrit à ce stage pour l’instant.`)
};

const tl_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang nagrerehistro sa camp na ito.`)
};

const vi_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa ai đăng ký trại này.`)
};

const ko_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 캠프에 아직 등록한 사람이 없습니다.`)
};

const de_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dieses Camp ist noch niemand angemeldet.`)
};

const ru_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На этот лагерь пока никто не записался.`)
};

const tr_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kampa henüz kimse kaydolmadı.`)
};

const it_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno si è ancora iscritto a questo camp.`)
};

const pl_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nikt się jeszcze nie zapisał na ten obóz.`)
};

const uk_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На цей табір ще ніхто не записався.`)
};

const hi_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस कैंप के लिए अभी किसी ने पंजीकरण नहीं कराया।`)
};

const ar_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يسجّل أحد في هذا المعسكر بعد.`)
};

const ms_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada sesiapa mendaftar untuk kem ini.`)
};

const bn_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই ক্যাম্পে এখনও কেউ নিবন্ধন করেননি।`)
};

const zh_tw2_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無人報名這個訓練營。`)
};

const zh_hk2_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無人報名這個訓練營。`)
};

const ur_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس کیمپ کے لیے ابھی کسی نے رجسٹر نہیں کیا۔`)
};

const fa_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز کسی در این اردو ثبت‌نام نکرده است.`)
};

const sw_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna aliyejisajili kwenye kambi hii bado.`)
};

const nl_event_session_register_none = /** @type {(inputs: Event_Session_Register_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog niemand ingeschreven voor dit kamp.`)
};

/**
* | output |
* | --- |
* | "Nobody is entered in this camp yet." |
*
* @param {Event_Session_Register_NoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_session_register_none = /** @type {((inputs?: Event_Session_Register_NoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Session_Register_NoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_session_register_none(inputs)
	if (locale === "ja") return ja_event_session_register_none(inputs)
	if (locale === "zh") return zh_event_session_register_none(inputs)
	if (locale === "es") return es_event_session_register_none(inputs)
	if (locale === "pt") return pt_event_session_register_none(inputs)
	if (locale === "id") return id_event_session_register_none(inputs)
	if (locale === "fr") return fr_event_session_register_none(inputs)
	if (locale === "tl") return tl_event_session_register_none(inputs)
	if (locale === "vi") return vi_event_session_register_none(inputs)
	if (locale === "ko") return ko_event_session_register_none(inputs)
	if (locale === "de") return de_event_session_register_none(inputs)
	if (locale === "ru") return ru_event_session_register_none(inputs)
	if (locale === "tr") return tr_event_session_register_none(inputs)
	if (locale === "it") return it_event_session_register_none(inputs)
	if (locale === "pl") return pl_event_session_register_none(inputs)
	if (locale === "uk") return uk_event_session_register_none(inputs)
	if (locale === "hi") return hi_event_session_register_none(inputs)
	if (locale === "ar") return ar_event_session_register_none(inputs)
	if (locale === "ms") return ms_event_session_register_none(inputs)
	if (locale === "bn") return bn_event_session_register_none(inputs)
	if (locale === "zh-TW") return zh_tw2_event_session_register_none(inputs)
	if (locale === "zh-HK") return zh_hk2_event_session_register_none(inputs)
	if (locale === "ur") return ur_event_session_register_none(inputs)
	if (locale === "fa") return fa_event_session_register_none(inputs)
	if (locale === "sw") return sw_event_session_register_none(inputs)
	if (locale === "nl") return nl_event_session_register_none(inputs)
	return en_event_session_register_none(inputs)
});